import React from 'react';
import { useHistory, useParams } from 'react-router-dom';

import FormHeader from './Common/FormHeader';
import FAQ from '../../../components/Misc/FAQ';
import Button from '../../../components/Buttons/Button';
import { useAccountContext } from './Data/accountContext';
import Header from './Common/Header';
import StepsAttentionModal from './Common/StepsAttentionModal';
import { saveOnboardingPercent } from '../../../services/RegistrationService';

import OnboardingDisclosureModal from '../../../components/Modals/OnBoardingDisclosureModal';
import MessageModal from '../../../components/Modals/MessageModal';
import { accountTypeCorporateInformMessage } from '../../../lib/data/message';
import StepsSubmitAttentionModal from './Common/StepsSubmitAttentionModal';

export default function FormBase({ children, header, subHeader, faq, save, pdfForm }) {
  const { key: verificationKey, form, accountId } = useParams();
  const history = useHistory();

  const {
    forms,
    setAccount,
    account,
    isLoading,
    setForms,
    getFormIndex,
    setErrorMessage,
    setIsLoading,
    isBussinessAccount,
    viewOnly,
  } = useAccountContext();
  // 0 when not loaded, 1 will show modal, 3+ will not show forever
  const [stepsAttentionIndicator, setStepsAttentionIndicator] = React.useState(0);
  const [openOnboardingModal, setOpenOnboardingModal] = React.useState({
    open: false,
    partiallyCompleted: true,
  });

  const [openRestrictedEmploymentTab, setOpenRestrictedEmploymentTab] =
    React.useState(false);
  const [openStepsSubmitAttentionModal, setOpenStepsSubmitAttentionModal] =
    React.useState(false);

  const currentFormIndex = getFormIndex(form);

  const updateForm = (err) => {
    // update completed form
    let copy = [...forms];
    copy[currentFormIndex].isCompleted = !err;

    setForms(copy);
  };

  const updateOnboardingPercent = async (acct, err) => {
    const currentForm = forms[currentFormIndex];

    if (currentForm.isCompleted || err) {
      return;
    }

    const onboardingPercent = parseInt(acct.onboardingPercent || 0) + currentForm.value;
    setAccount({ ...acct, onboardingPercent: onboardingPercent + '' }); // must convert to string, getting charat error

    await saveOnboardingPercent(onboardingPercent);
  };

  const handleSave = async () => {
    try {
      setIsLoading(true);
      const { acct, err } = await save();

      await updateOnboardingPercent(acct, err);
      updateForm(err);

      return err;
    } catch (error) {
      console.log(error);
      setErrorMessage({
        title: 'Ooopss...',
        msg: 'Unable to update application.',
        errMsg: error?.message || error,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleNavigate = async (type, gotoIndex) => {
    if (gotoIndex === currentFormIndex) {
      return;
    }
    let err = false;
    if (form !== 'submit' && !viewOnly) {
      err = await handleSave();

      if (err) {
        if (stepsAttentionIndicator === 0) {
          setStepsAttentionIndicator(stepsAttentionIndicator + 1);
        }

        // disable next when has error
        if (type === 'NEXT') {
          return;
        }
      }
    }

    if (type === 'BACK') {
      gotoIndex = currentFormIndex - 1;
    } else if (type === 'NEXT') {
      gotoIndex = currentFormIndex + 1;
    }

    if (isBussinessAccount() && getFormIndex('employment') === gotoIndex) {
      if (type === 'GOTO') {
        setOpenRestrictedEmploymentTab(true);
        return;
      } else if (type === 'BACK') {
        gotoIndex = gotoIndex - 1;
      } else if (type === 'NEXT') {
        gotoIndex = gotoIndex + 1;
      }
    }

    if (getFormIndex('submit') === gotoIndex) {
      for (let index = 0; index < forms.length; index++) {
        const element = forms[index];

        if (
          (element.name === 'employment' && isBussinessAccount()) ||
          element.name === 'submit'
        ) {
          console.log(1);
        } else if (!element.isCompleted && element.name !== form) {
          console.log(2, form);
          return setOpenStepsSubmitAttentionModal(true);
        } else if (element.name === form && err) {
          console.log(3);
          return setOpenStepsSubmitAttentionModal(true);
        }
      }
    }

    let newPath = `/registration/${forms[gotoIndex].name}/${verificationKey}`;

    if (window.location.pathname.substring(0, 4) === '/app') {
      newPath = `/app/registration/${forms[gotoIndex].name}/${accountId || ''}`;
    }

    history.push(newPath);
  };

  const handleClose = () => {
    setOpenOnboardingModal(false);
  };

  return (
    <React.Fragment>
      <Header activeForm={form} navigate={handleNavigate} />
      <div className="register-b">
        <div className="register-b-ls">
          <FormHeader
            header={header}
            subHeader={subHeader || `Step ${currentFormIndex + 2} of ${forms.length + 1}`}
          />
          <div className="ls-b">
            {children}
            <div className="stepper-buttons">
              {!!currentFormIndex && (
                <div className="grd-cell-none">
                  <Button
                    label="Back"
                    disabled={isLoading}
                    onClick={() => handleNavigate('BACK')}
                  />
                </div>
              )}

              <div className="grd-cell">
                {form !== 'submit' && (
                  <Button
                    loading={isLoading}
                    disabled={isLoading}
                    label="Next"
                    onClick={() => handleNavigate('NEXT')}
                  />
                )}
              </div>
              <div className="grd-cell-none">
                {form === 'submit' ? (
                  <Button
                    disabled={
                      isLoading ||
                      (account.accountType === 'J'
                        ? !account.imgSignature || !account.coApplicantSignature
                        : !account.imgSignature)
                    }
                    loading={isLoading}
                    label="Submit"
                    onClick={async () => {
                      try {
                        await save();
                        setOpenOnboardingModal({
                          open: true,
                          partiallyCompleted: false,
                        });
                      } catch (error) {
                        setErrorMessage({
                          title: 'Ooopss...',
                          msg: 'Unable to update application.',
                          errMsg: error?.message || error,
                        });
                      }
                    }}
                  />
                ) : (
                  !viewOnly && (
                    <Button
                      loading={isLoading}
                      disabled={isLoading}
                      label="Save and Exit"
                      onClick={async () => {
                        await handleSave();
                        setOpenOnboardingModal({
                          open: true,
                          partiallyCompleted: true,
                        });
                      }}
                    />
                  )
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="register-b-rs">
          {pdfForm ? (
            <div className="graphics-w">{account.accountId && pdfForm}</div>
          ) : (
            <div className="faq-w">
              <FAQ pageName={faq} />
            </div>
          )}
        </div>
      </div>
      {stepsAttentionIndicator === 1 && (
        <StepsAttentionModal
          onClose={() => {
            setStepsAttentionIndicator(stepsAttentionIndicator + 1);
          }}
          open={stepsAttentionIndicator === 1}
        />
      )}

      {openOnboardingModal.open && (
        <OnboardingDisclosureModal
          open={openOnboardingModal.open}
          onClose={handleClose}
          partiallyCompleted={openOnboardingModal.partiallyCompleted}
        ></OnboardingDisclosureModal>
      )}
      {openRestrictedEmploymentTab && (
        <MessageModal
          modalTitle="Attention"
          content={accountTypeCorporateInformMessage}
          open={openRestrictedEmploymentTab}
          onClose={() => {
            setOpenRestrictedEmploymentTab(false);
          }}
        />
      )}
      {openStepsSubmitAttentionModal && (
        <StepsSubmitAttentionModal
          forms={forms}
          isBussinessAccount={isBussinessAccount()}
          open={openStepsSubmitAttentionModal}
          onClose={() => {
            setOpenStepsSubmitAttentionModal(false);
          }}
        />
      )}
    </React.Fragment>
  );
}
